/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mergeClasses } from "../../packages/fluent9";

import { useStyles } from "./Flex.styles";
import { FlexProps } from "./FlexProps";

/**
 * The React hook to get the CSS class name for the Flex component.
 * @param props The properties.
 * @returns The class name.
 */
export const useClassName = (props: FlexProps): string => {
    const { className, horizontal } = props;
    const styles = useStyles();
    const directionClassName = horizontal ? styles.horizontal : styles.vertical;
    const baseClassName = mergeClasses(styles.root, directionClassName);

    return className ? mergeClasses(baseClassName, className) : baseClassName;
};
